/**
 * Global kill-switch for the product tour / onboarding.
 *
 * Temporarily disabled: hides the help button (TourButton) and prevents any
 * onboarding tour from auto-starting. Flip back to `true` to re-enable both.
 */
export const TOUR_ENABLED = false;
